// extracted by mini-css-extract-plugin
module.exports = {"table":"headersMapping_table__Z6m2j"};